import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { AfTranslateDirective } from "../../modules/translate/directive/af-translate.directive";
import { NgClass } from "@angular/common";

@Component({
    selector: 'export-format-modal',
    templateUrl: './export-format-modal.component.html',
    standalone: true,
    imports: [AfTranslateDirective, NgClass]
})
export class ExportFormatModalComponent{
  constructor(private translate:AfTranslateFactory,
    private dialogRef: DynamicDialogRef<ExportFormatModalComponent>,
    private dialogConfig: DynamicDialogConfig){}
  configuration: any = this.dialogConfig.data;
  exportFormat: any = {
    title: this.configuration.title?this.configuration.title:this.translate.instant('common.export-excel'),
    selectedFormat: ''
  }

  selectFormat(format:string) {
    this.exportFormat.selectedFormat = format;
    this.handleAccept();
  }

  handleAccept(){
    this.dialogRef.close({
      result: 'ok',
      selectedFormat: this.exportFormat.selectedFormat
    });
  };

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  };
}
